import { BasicTable } from "@/view/components/BasicTable"
import { Spinner } from "@/view/components/ui/spinner"
import { FilterReports } from "../components/FilterReports"
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/view/components/ui/alert-dialog"
import ProgressBar from "@ramonak/react-progress-bar"
import { Download } from "lucide-react"
import { Button } from "@/view/components/ui/button"
import { useReportReferralController } from "./useReportReferralController"
import { Searchs } from "../components/Search"

export const ReportReferral = () => {
  const {
    getPageCount,
    getPageIndex,
    handleNextPage,
    handlePreviousPage,
    isFetching,
    isLoading,
    table,
    setParams,
    handleExportToExcel,
    isExporting,
    exportProgress,
    filters,
  } = useReportReferralController()

  return (
    <div className="w-full">
      <div className="mb-5 flex flex-col items-center justify-between gap-4 max-md:w-full md:flex-row md:gap-0">
        <div className="flex gap-4">
          <Searchs setParams={setParams} />
          <FilterReports
            filters={filters}
            setParams={setParams}
            isCouponOrReferrals={true}
          />
        </div>
        {isExporting && (
          <AlertDialog open={isExporting}>
            <AlertDialogContent className="w-96">
              <AlertDialogHeader>
                <AlertDialogTitle>
                  Seu download está em andamento
                </AlertDialogTitle>
              </AlertDialogHeader>
              <ProgressBar
                completed={exportProgress}
                maxCompleted={100}
                bgColor="#EA0356"
                width="330px"
              />
            </AlertDialogContent>
          </AlertDialog>
        )}
        <Button
          onClick={handleExportToExcel}
          className="flex items-center justify-center bg-primary font-semibold text-white hover:bg-primary max-md:w-full"
          disabled={isExporting}
        >
          <Download className="mr-2 h-5 w-5" />
          Exportar registros
        </Button>
      </div>
      {(isFetching || isLoading) && (
        <div className="flex h-screen items-center justify-center">
          <Spinner />
        </div>
      )}
      {!isFetching && table && (
        <BasicTable
          type="table with lines"
          getPageCount={getPageCount}
          getPageIndex={getPageIndex}
          handleNextPage={handleNextPage}
          handlePreviousPage={handlePreviousPage}
          table={table}
        />
      )}
    </div>
  )
}
